import {
    GetTradingSessionsByIdInput,
    GetTradingSessionsByIdResponse,
    GetTradingSessionsInput,
    GetTradingSessionsResponse,
    GetTradingSessionsStatsInput,
    GetTradingSessionsStatsResponse,
    PostTradingSessionInput,
    PutTradingSessionInput,
    PutTradingSessionResponse,
} from "../../types/api/tradingSession";
import { request } from "../apiService";

export const getTradesSessions = async (input: GetTradingSessionsInput) => {
    return await request<GetTradingSessionsResponse, GetTradingSessionsInput>(
        `/v3/tradingsessions`,
        {
            input,
        }
    );
};

export const getTradingSessionById = async ({
    sessionId,
    userId,
}: GetTradingSessionsByIdInput) => {
    return await request<GetTradingSessionsByIdResponse>(
        `/v3/tradingsessions/${sessionId}/trades?userId=${userId}`
    );
};

export const getTradeImage = async (
    userId: string,
    sessionId: string,
    tradeId: string
) => {
    return await request<{ url: string }>(
        `/v3/tradingsessions/${sessionId}/trades/${tradeId}/image?userId=${userId}`
    );
};

export const getSessionPlan = async (userId: string, sessionId: string) => {
    return await request<{ url: string }>(
        `/v3/tradingsessions/${sessionId}/plan?userId=${userId}`
    );
};

export const postTradesSession = async (input: PostTradingSessionInput) => {
    const formData = new FormData();
    (Object.keys(input) as Array<keyof PostTradingSessionInput>).forEach(
        (key) => {
            if (key === "trades") {
                formData.append(`trades`, JSON.stringify(input.trades));
            } else if (key !== "files") {
                formData.append(key, String(input[key]));
            }
        }
    );

    if (input.files) {
        for (const [tradeId, file] of Object.entries(input.files)) {
            if (file) {
                formData.append(tradeId, file);
            }
        }
    }

    return await request<void>(`/v3/tradingsessions`, {
        method: "POST",
        headers: {
            "Content-Type": "multipart/form-data",
        },
        input: formData,
    });
};

export const putTradesSession = async (
    userId: string,
    sessionId: string,
    input: PutTradingSessionInput
) => {
    const formData = new FormData();
    (Object.keys(input) as Array<keyof PutTradingSessionInput>).forEach(
        (key) => {
            if (key === "trades") {
                formData.append(`trades`, JSON.stringify(input.trades));
            } else if (key !== "files") {
                formData.append(key, String(input[key]));
            }
        }
    );

    if (input.files) {
        for (const [tradeId, file] of Object.entries(input.files)) {
            if (file) {
                formData.append(tradeId, file);
            }
        }
    }

    return await request<PutTradingSessionResponse>(
        `/v3/tradingsessions/${sessionId}?userId=${userId}`,
        {
            method: "PUT",
            headers: {
                "Content-Type": "multipart/form-data",
            },
            input: formData,
        }
    );
};

export const deleteTradingSession = async (sessionId: string) => {
    return await request<void>(`/v3/tradingsessions/${sessionId}`, {
        method: "DELETE",
    });
};

export const getTradingSessionsStats = async (
    input: GetTradingSessionsStatsInput
) => {
    return await request<
        GetTradingSessionsStatsResponse,
        GetTradingSessionsStatsInput
    >(`/v3/tradingsessions/stats`, {
        input,
    });
};
